<template>
    <div class="container" :style="{ height: bodyHeight + 'px' }">
        <navBar :title="title" @onClickLeft="handleBack">
        </navBar>
        <img class="title" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/title1.png" alt="">
        <div class="list">
            <img class="icon1" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/icon1.png"
                alt="">
            <div class="list_cell_pad">
                <div class="list_cell" v-for="(item, index) in list" :key="index">
                    <img class="goodsPicture" :src="item.goodsPicture" alt="">
                    <div class="goodsname">{{ item.goodsname }}</div>
                    <div class="btn" v-if='!item.exchange&&!item.complete'  @click="show(item)">立即兑换</div>
                    <div class="btn_over" v-if='!item.exchange&&item.complete'>立即兑换</div>
                    <div class="btn_over" v-if='item.exchange'>已兑换</div>
                </div>
            </div>
        </div>
        <van-action-sheet v-model="showAction" title="音视频会员兑换"  @close="onCancel">
            <div class="content">
                <div class="goods_mes">
                    <img class="goods_img" :src="actionData.goodsPicture" alt="">
                    <div class="goods_title">{{ actionData.goodsname }}</div>
                </div>
                <div class="action_title">直冲账号</div>
                <div class="input">
                    <input type="text" @input="inputChange" v-model="value" placeholder="请输入帐号" maxlength="11">
                </div>
                <div class="action_toast">虚拟权益一旦兑换不支持退换</div>
                <div class="recharge_btn" @click="submit" v-show="changeColor">输入账号 完成充值</div>
                <div class="recharge_btn_before" @click="submit" v-show="!changeColor">输入账号 完成充值</div>
            </div>
        </van-action-sheet>
    </div>
</template>


<script>
import navBar from '../components/navBar.vue';
export default {
    components: {
        navBar,
    },
    data() {
        return {
            bodyHeight: 700,
            list: [],
            showAction: false,
            actionData: {},
            value: '',
            isPhone: /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/,
            title: this.$route.meta.title,
            changeColor:false,
        }
    },
    created() {
        this.bodyHeight = window.screen.height;
        this.getList();
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
        },
        getList() {
            this.$api.entityCard.equityList({}).then(({ success, data }) => {
                if (success) {
                    this.list = data;
                }
            })
        },
        show(item) {
            this.actionData = item;
            this.showAction = true;
        },
        onCancel(){
            this.value = '';
        },
        inputChange() {
            this.value = this.value.replace(/[^\d]/g, "");
            if (this.value !== "") {
                this.changeColor = true;
            } else {
                this.changeColor = false;
            }
        },
        submit() {
            if (this.value == '') {
                this.$toast({
                    message: '请输入帐号',
                    duration: 2000,
                });
                return
            }
            let obj = {
                "mobile": this.value,
                "parvalue": this.actionData.sellprice,
                "productSn": this.actionData.goodsid,
                "productName": this.actionData.goodsname,
            }
            this.$api.entityCard.equitySave(obj).then(({ success, data }) => {
                if (success) {
                    this.$toast({
                        message: '兑换申请已提交，请在对应兑换程序查看兑换结果',
                        duration: 2000,
                    });
                    this.getList();
                    this.showAction = false;
                }
            })
        }
    },
}
</script>

<style lang="less" scoped>
.van-action-sheet__close {
    position: absolute;
    padding: 0;
    top: 0.7rem;
    right: 0.864rem;
    font-size: 20px;
}

.container {
    width: 100%;
    height: 100%;
    background-image: url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/bgc1.png');
    background-size: 100% 100%;

}

.title {
    padding-top: 90px;
    width: 588px;
    display: block;
    margin: 0 auto 70px;
}

.list {
    width: 696px;
    height: 765px;
    margin: 0 auto;
    background-image: url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/bgc2.png');
    background-size: 100% 100%;
    position: relative;

    .icon1 {
        width: 94px;
        position: absolute;
        bottom: -36px;
        right: -26px;
    }

    .list_cell_pad {
        padding: 188px 76px 0;

        .list_cell {
            // width: 188px;
            // height: 206px;
            width: 32%;
            margin-right: 2%;
            margin-bottom: 10px;
            display: inline-block;
            background-image: url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/bgc3.png');
            background-size: 100% 100%;

            .goodsPicture {
                width: 90px;
                border: 10px;
                display: block;
                margin: 20px auto 10px;
            }

            .goodsname {
                color: #464646;
                font-size: 24px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
            }

            .btn_over,
            .btn {
                width: 116px;
                height: 38px;
                background: #D8D8D8;
                // box-shadow: 0px 5px 0px 0px #F0A044;
                border-radius: 19px;
                margin: 10px auto 26px;
                color: #fff;
                font-size: 24px;
                text-align: center;
                line-height: 38px;
            }

            .btn {
                background: linear-gradient(180deg, #FF9D5D 0%, #FF4D24 100%);
                // box-shadow: 0px 5px 0px 0px #F0A044, inset 0px 1px 0px 0px #FDF3B1;
            }
        }

        .list_cell:nth-child(3n) {
            margin-right: 0;
        }
    }
}

.content {
    padding: 0 50px 50px;

    .goods_mes {
        position: relative;
        padding-left: 260px;
        height: 160px;

        .goods_img {
            position: absolute;
            top: 0;
            left: 0;
            width: 240px;
            height: 160px;
        }

        .goods_title {
            color: #333333;
            font-size: 30px;
        }
    }

    .action_title {
        margin: 38px 0 14px;
        color: #333333;
        font-size: 30px;
    }

    .input {
        height: 96px;
        background: #F5F5F5;
        padding-left: 50px;
        border-radius: 10px;

        input {
            height: 100%;
            border: none;
            width: 100%;
            background: transparent;
            font-size: 28px;
        }

        input:-webkit-autofill {
            background: #F5F5F5 !important;
        }

        ::placeholder {
            color: #C1C1C1;
        }
    }

    .action_toast {
        margin: 20px 0;
        font-size: 26px;
        color: #969696;
    }

    .recharge_btn,.recharge_btn_before {
        color: #fff;
        font-size: 30px;
        text-align: center;
        line-height: 80px;
        height: 80px;
        background: linear-gradient(90deg, #C94DF9 0%, #7E4CF8 100%);
        border-radius: 50px;
    }
    .recharge_btn_before {
        background: #f5f5f5;
        color: #333;
    }
}
</style>